import React from 'react'
import './style/AboutUs.css'
import photo from '../imgs/Sans-titre.png'
import Skill from './Skill'

function AboutUs() {
    return (
        <div className="aboutUs" id="about">
            <div className="photo">
                <img src={photo} alt="photo" />
            </div>
            <div className="about">
                <span>About Us</span>
                <h2>Why you Hire Me!</h2>
                <p>Exercitation aute proident non tempor exercitation deserunt pariatur velit ad. Qui ut dolore eiusmod cillum proident minim consectetur ullamco do occaecat non amet officia non. Sit id sunt voluptate ut cupidatat veniam ad .</p>
                <div className="skills">
                    <Skill title="Ui/Ux Design" per="85"/>
                    <Skill title="Web Design" per="75"/>
                    <Skill title="Html/Css" per="90"/>
                    <Skill title="Wordpress" per="65"/>
                </div>
            </div>
        </div>
    )
}

export default AboutUs
